import React from "react";
import PropTypes from "prop-types";
import { useAccessTier } from "contexts/AccessTierContext";
import { AI_TOOL_NAMES } from "../../constants";

const InitialMessageDescription = ({
  toolName,
  resourceTitle,
  inContent,
  signupPath
}) => {
  const { isSignedOut, isFree, isAPlus } = useAccessTier();
  const amplitudeText = isSignedOut
    ? "Sign up for LitCharts A+ Teacher"
    : "Upgrade to LitCharts A+ Teacher and get 250 uses per month.";

  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      return inContent ? (
        <div className="body-2 ask-litcharts-ai--description">
          Combining the literary wisdom of LitCharts and the power of AI, I can
          answer your questions about <i>{resourceTitle}</i> or any other title
          we cover, instantly.
        </div>
      ) : (
        <div className="body-2 ask-litcharts-ai--description">
          Need help with literature? Ask me anything. Combining the literary
          wisdom of LitCharts and the power of AI, I&apos;m here to provide
          instant answers and explanations.
          {!isSignedOut && <> Complete these steps to get help in seconds:</>}
        </div>
      );
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
      return inContent ? (
        <div className="body-2 ask-litcharts-ai--description">
          I can create discussion questions for <i>{resourceTitle}</i> or any
          other title we cover instantly.{" "}
          {isSignedOut && (
            <>
              <a
                href={signupPath}
                data-amplitude-text={amplitudeText}
                data-amplitude="aiContentDqgChatBubble"
              >
                Sign up for LitCharts A<sup>+</sup> Teacher{" "}
              </a>
              and get 250 uses per month.
            </>
          )}
          {(isFree || isAPlus) && (
            <>
              <a
                href={signupPath}
                data-amplitude-text={amplitudeText}
                data-amplitude="aiContentDqgChatBubble"
              >
                Upgrade to LitCharts A<sup>+</sup> Teacher{" "}
              </a>
              and get 250 uses per month.
            </>
          )}
        </div>
      ) : (
        <div className="body-2 ask-litcharts-ai--description">
          Combining the literary wisdom of LitCharts and the power of AI, I can
          help you instantly create discussion questions that will get people
          talking. Just complete these steps:
        </div>
      );
    case AI_TOOL_NAMES.QUIZ_QUESTIONS:
      return (
        <div className="body-2 ask-litcharts-ai--description">
          Combining the literary wisdom of LitCharts and the power of AI, I can
          instantly create focused quiz questions that you can use or modify as
          you desire. Just complete these steps:
        </div>
      );
    case AI_TOOL_NAMES.ESSAY_PROMPTS:
      return (
        <div className="body-2 ask-litcharts-ai--description">
          Combining the literary wisdom of LitCharts and the power of AI, I can
          instantly create thought-provoking essay prompts that you can use or
          modify as you desire. Just complete these steps:
        </div>
      );
    default:
      return null;
  }
};

InitialMessageDescription.propTypes = {
  inContent: PropTypes.bool,
  resourceTitle: PropTypes.string,
  toolName: PropTypes.oneOf(Object.values(AI_TOOL_NAMES)).isRequired
};

export default InitialMessageDescription;
